export type TesterShot = {
  id: string
  label: string
  dataUrl: string
  error?: string
}

const shotsByKey = new Map<string, TesterShot[]>()

export function saveTesterShots(key: string, shots: TesterShot[]): void {
  shotsByKey.set(key, shots)
}

export function readTesterShots(key: string | undefined): TesterShot[] {
  if (!key) return []
  return shotsByKey.get(key) ?? []
}
